<template>
  <SalesPlayDrawerCard>
    <div class="drawer-section">
      <div class="drawer-sectionLabel">POWER DIALER</div>
      <p class="drawer-hint">
        This action node makes this sales play's
        qualified candidates available to reps in the power dialer queue.
      </p>
      <router-link class="dialerLink" to="/dialer/human">
        Open the dialer queue
        <AppIcon name="arrow_up_right" :size="14" />
      </router-link>
    </div>
  </SalesPlayDrawerCard>
</template>

<script setup lang="ts">
import SalesPlayDrawerCard from './SalesPlayDrawerCard.vue'
import AppIcon from '../../../components/AppIcon.vue'

// The dialer node carries no editable config, so this card is read-only —
// no props consumed beyond the standard drawer-card context, no Apply/Cancel.
defineProps<{
  playId: string
  pipelineId: string | null
  nodeIndex: number
}>()
</script>

<style scoped>
.drawer-hint {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-tertiary);
  line-height: var(--lh-normal);
  margin: 0 0 var(--space-3);
}
.dialerLink {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-accent);
  text-decoration: none;
}
.dialerLink:hover {
  color: var(--color-text-primary);
}
</style>
